"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreviewVersion = exports.isAppPreview = exports.getAppTargetByNamespace = void 0;
var contants_1 = require("./contants");
function getAppTargetByNamespace(ns) {
    return contants_1.APP_TARGETS_BY_NAMESPACE[ns || 'standard'];
}
exports.getAppTargetByNamespace = getAppTargetByNamespace;
function isAppPreview(appConfig) {
    return isPreviewVersion(appConfig.version);
}
exports.isAppPreview = isAppPreview;
function isPreviewVersion(version) {
    if (!version)
        return false;
    return version.startsWith('PR-');
}
exports.isPreviewVersion = isPreviewVersion;
//# sourceMappingURL=app-utils.js.map